import { useMemo } from 'react';
import {
  parameterTemplatesSystemPackageMaxFileSize,
  transformSystemPackageApplicationFileListToSelect,
} from '../application-version-fields/applicationVersionFields.util';
import type {
  UseSystemPackageVersionConfigureStepParams,
  UseSystemPackageVersionConfigureStepReturn,
} from './systemPackageVersionConfigureStep.model';

export function useSystemPackageVersionConfigureStep({
  existingTemplates,
}: UseSystemPackageVersionConfigureStepParams): UseSystemPackageVersionConfigureStepReturn {
  const maxFileSize = useMemo(() => parameterTemplatesSystemPackageMaxFileSize, []);

  return useMemo(
    () => ({
      inputOptions: { existingTemplates: transformSystemPackageApplicationFileListToSelect(existingTemplates) },
      maxFileSize,
    }),
    [existingTemplates, maxFileSize],
  );
}
